import { connect } from 'react-redux'
import {
  closeKindModal,
} from '../actions'
import TrainPositionKindModal from '../components/train_positions/TrainPositionKindModal'

const mapStateToProps = state => {
  const { themeName } = state.themeReducer

  return {
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeKindModal: () => {
      dispatch(closeKindModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainPositionKindModal)
